import { combineReducers } from 'redux';
import loader from './loader';
import eSign from './eSign';
import userOrders from './userOrders';
import referralInfo from './referralInfo';
import driverAccess from './driverAccess';

export default combineReducers({
  eSign,
  loader,
  userOrders,
  referralInfo,
  driverAccess,
});
